@if (loading) {
  <div class="idv-loading-background">
    <spinner></spinner>
  </div>
} @else {

  <div class="routed-component-layout">
    <div class="routed-component-body">
      <div class="routed-component-title-block">
        @if (applicantMustIdv) {
          <h2>{{ "REGISTRATION.APPLICANT_PRE_IDV_PAGE.TITLE_MUST_IDV" | translate : {name: applicantFirstName } }}</h2>
        } @else {
          <h2>{{ "REGISTRATION.APPLICANT_PRE_IDV_PAGE.TITLE" | translate : {name: applicantFirstName } }}</h2>
        }
        <div class="image docuploadimage"></div>

        <p><strong>{{ "REGISTRATION.APPLICANT_PRE_IDV_PAGE.SUBTITLE_1" | translate }}</strong></p>
      </div>

      <p [innerHTML]="'REGISTRATION.APPLICANT_PRE_IDV_PAGE.PARAGRAPH_1' | translate"></p>

      <div>
        <span [innerHTML]="'REGISTRATION.APPLICANT_PRE_IDV_PAGE.NECESSARY_STEPS.INTRO' | translate"></span>
        <ul>
          <li *ngFor="let step of necessaryIdvSteps" [innerHTML]="'REGISTRATION.APPLICANT_PRE_IDV_PAGE.NECESSARY_STEPS.' + step | translate"></li>
        </ul>
      </div>

      @if (applicantMustIdv) {
        <p><strong>{{ "REGISTRATION.APPLICANT_PRE_IDV_PAGE.INTRO_CTA" | translate }}</strong></p>

        <div class="idv-cta-section">
          <button
            data-cy="IDV_Button_VerifyYourIdentityButton"
            class="primary centered"
            (click)="proceedToIDV()">
            {{ "REGISTRATION.APPLICANT_PRE_IDV_PAGE.CTA" | translate }}
          </button>
        </div>
      }


      <p [innerHTML]="'REGISTRATION.APPLICANT_PRE_IDV_PAGE.PARAGRAPH_2' | translate"></p>

      <p *ngIf="idvHelpPageUrl" [innerHTML]="'REGISTRATION.APPLICANT_PRE_IDV_PAGE.HELP_PARAGRAPH' | translate : {idvHelpPageUrl, privacyPolicyLink}"></p>

      @if (applicantMustIdv) {
        <p>
          <strong>{{ "REGISTRATION.APPLICANT_PRE_IDV_PAGE.SUBTITLE_2" | translate }}</strong><br/>
          <span [innerHTML]="'REGISTRATION.APPLICANT_PRE_IDV_PAGE.PARAGRAPH_3_MUST_IDV' | translate"></span>
        </p>
      } @else {
        <p>
          <strong>{{ "REGISTRATION.APPLICANT_PRE_IDV_PAGE.SUBTITLE_2" | translate }}</strong><br/>
          <span [innerHTML]="'REGISTRATION.APPLICANT_PRE_IDV_PAGE.PARAGRAPH_3' | translate"></span>
        </p>
        <p [innerHTML]="'REGISTRATION.APPLICANT_PRE_IDV_PAGE.PARAGRAPH_4' | translate"></p>

        <div class="navigation-controls-layout">
          <div class="idv-cta-section">
            <button
              data-cy="IDV_Button_LearnMore"
              class="primary"
              (click)="onClickCTA()">
              {{ "REGISTRATION.APPLICANT_PRE_IDV_PAGE.CTA_LEARN_MORE" | translate }}
            </button>
          </div>
        </div>
      }

    </div>
  </div>
}